
import React from 'react';
import { LucideIcon } from 'lucide-react';

interface StatCardProps {
  label: string;
  value: string;
  trend?: string;
  trendUp?: boolean;
  icon: LucideIcon;
  colorClass: string;
  comparisonText?: string;
  onClick?: () => void;
}

export const StatCard: React.FC<StatCardProps> = ({ 
  label, 
  value, 
  trend, 
  trendUp, 
  icon: Icon, 
  colorClass,
  comparisonText = "vs last month",
  onClick
}) => {
  return (
    <div 
      onClick={onClick}
      className={`bg-slate-800 border border-slate-700 rounded-xl p-5 transition-all duration-200 ${
        onClick ? 'cursor-pointer hover:border-indigo-500/50 hover:bg-slate-800/80 hover:shadow-lg hover:shadow-indigo-500/10' : ''
      }`}
    >
      <div className="flex justify-between items-start mb-4">
        <div>
          <p className="text-slate-400 text-sm font-medium">{label}</p>
          <h3 className="text-2xl font-bold text-white mt-1">{value}</h3>
        </div>
        <div className={`p-2 rounded-lg ${colorClass} bg-opacity-10`}>
          <Icon className={colorClass} size={20} />
        </div>
      </div>
      {trend && (
        <div className="flex items-center gap-1">
          <span className={`text-xs font-semibold ${trendUp ? 'text-emerald-400' : 'text-rose-400'}`}>
            {trend}
          </span>
          <span className="text-xs text-slate-500">{comparisonText}</span>
        </div>
      )}
    </div>
  );
};
